import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ReduxFormContext } from 'redux-form/lib/ReduxFormContext';
import { makeGetErrorsForFields } from '../../reducers/validationReducer';
import HideOnError from './HideOnError';

const outerPropTypes = {
  /**
   * The field names to check for error codes in the validation
   */
  fields: PropTypes.arrayOf(PropTypes.string).isRequired,
  /**
   * If on of these error codes is present in one of the fields specified in 'fields', we will
   * hide the children
   */
  errorCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const ConnectedHideOnError = connect(() => {
  const getErrorsForFields = makeGetErrorsForFields();

  return (state, props) => {
    const errors = getErrorsForFields(state.enhancedForm.validation, props);

    return {
      hasError: !!errors.find(error => props.errorCodes.includes(error.code)),
    };
  };
}, null)(HideOnError);
ConnectedHideOnError.propTypes = {
  ...outerPropTypes,
  form: PropTypes.string.isRequired,
};

const FormNameProvider = props => {
  const { form } = useContext(ReduxFormContext);
  return <ConnectedHideOnError {...props} form={form} />;
};
FormNameProvider.propTypes = outerPropTypes;

export default FormNameProvider;
